import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthRequest } from "@dto/authRequest";
import { AuthenticationService } from "@services/authentication/authentication.service";
import { FormService } from "@services/form/form.service";
import { MessageService } from "@services/message/message.service";
import { CustomersService } from "@services/entity/customers.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ReleaseNotesDialogComponent } from "../../dialog/release-notes-dialog/release-notes-dialog.component";
import { StripeInfosService } from "@services/entity/stripe-infos.service";
import { StripeInfo } from "@models/stripeInfo";
import { Roles } from "../../../enums/roles.enum";
import { isEmpty } from "rxjs/operators";
import { isNullOrUndefined } from "is-what";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  private _returnUrl: string;
  public _message: string;

  public currentVersion: string;
  public latestVersion: string;
  public hideReleaseNotes: boolean;
  public deliveryNote: boolean;

  public whitelabel: string;
  public whitelabelURL: string =
    "https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/";

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(
    @Inject("BASE_URL") private baseUrl: string,
    private authenticationService: AuthenticationService,
    private stripeInfosService: StripeInfosService,
    public formService: FormService,
    public messageService: MessageService,
    public customersService: CustomersService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private dialog: NgbModal
  ) {}

  ngOnInit(): void {
    this.formService.form = new UntypedFormGroup({
      username: new UntypedFormControl("", [Validators.required]),
      password: new UntypedFormControl("", [Validators.required]),
    });

    this._returnUrl =
      this.activatedRoute.snapshot.queryParams["returnUrl"] || "/";
    this._message = this.activatedRoute.snapshot.queryParams["message"] || "";
  }

  ngAfterViewInit() {
    this.whitelabel = localStorage.getItem("whitelabel");
  }

  public loginUser(loginFormValue) {
    this.spinner.show();
    this.messageService.clearErrors();
    const login = { ...loginFormValue };

    const authRequest: AuthRequest = {
      email: login.username,
      password: login.password,
      //clientURI: this.baseUrl + 'auth/forgotpassword',
    };

    this.authenticationService.loginUser(authRequest).subscribe(
      (result) => {
        localStorage.setItem("accessToken", result.accessToken);
        localStorage.setItem("refreshToken", result.refreshToken);
        localStorage.setItem("userId", result.userId);
        localStorage.setItem("customerId", result.customerId.toString());
        this.authenticationService.sendAuthStateChangeNotification(
          result.isAuthSuccessful
        );

        if (
          this.authenticationService.userHasRole(Roles.Operator) &&
          (this._returnUrl === "/" || !this._returnUrl)
        ) {
          localStorage.setItem("pool-url", "");
          this.customersService
            .getCustomerByName("CUBOS-Pool")
            .then((pool) =>
              localStorage.setItem("pool-url", "/pool/" + pool.id.toString())
            );
          this._returnUrl = "/operator";
        }
        this.router.navigate([this._returnUrl]);
        this.spinner.hide();
        this.checkVersion();
      },
      (error) => {
        console.log(error);
        if (isNullOrUndefined(error)) {
          this.messageService.setError(
            "Das hat nicht funktioniert... Bitte prüfen Sie Ihre Internetverbindung."
          );
        } else {
          this.messageService.setError(error);
        }
        this.spinner.hide();
      }
    );
  }

  checkVersion() {
    this.latestVersion = "2.8.10";
    this.currentVersion = localStorage.getItem("appVersion");
    this.hideReleaseNotes = localStorage.getItem("hideReleaseNotes") === "true";

    if (this.currentVersion == null || this.currentVersion === "undefined") {
      localStorage.setItem("appVersion", this.latestVersion);
      return;
    }

    let cl = this.currentVersion.split(".");
    let lv = this.latestVersion.split(".");
    if (cl[0] >= lv[0]) {
      if (cl[1] >= lv[1]) {
        if (cl[2] >= lv[2]) {
          console.log(
            `CUBOS.Connect version ${this.currentVersion} is up-to-date.`
          );
          if (!this.hideReleaseNotes) {
            this.openReleaseNotesDialog();
          }
        } else {
          this.openReleaseNotesDialog();
        }
      } else {
        this.openReleaseNotesDialog();
      }
    } else {
      this.openReleaseNotesDialog();
    }
  }

  openReleaseNotesDialog() {
    console.log(
      `CUBOS.Connect was updated from ${this.currentVersion} to version ${this.latestVersion}.`
    );
    this.currentVersion = this.latestVersion;
    localStorage.setItem("appVersion", this.latestVersion);
    localStorage.setItem("hideReleaseNotes", "true");

    window.setTimeout(() => {
      const dialogRef = this.dialog.open(ReleaseNotesDialogComponent, {
        centered: true,
        size: "xl",
        backdrop: "static",
      });
    }, 2000);
  }
}
